// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"5c7c8a64","777":"fe2e975d"}[chunkId] + ".chunk.js";
};